<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Filtros -->
      <div class="row mb-3 g-2">
        <div class="col-md-5">
          <input type="text" class="form-control" placeholder="Buscar producto por nombre" v-model="busqueda" />
        </div>
        <div class="col-md-4">
          <select class="form-select" v-model="ordenarPor">
            <option value="">Ordenar por...</option>
            <option value="nombre-asc">Nombre (A-Z)</option>
            <option value="nombre-desc">Nombre (Z-A)</option>
          </select>
        </div>
        <div class="col-md-3">
          <button class="btn btn-secondary w-100" @click="limpiarFiltros">Limpiar</button>
        </div>
      </div>

      <!-- Toast de alerta -->
      <div
        v-if="mostrarToast"
        class="toast-container position-fixed top-0 end-0 p-3"
        style="z-index: 1055"
      >
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Inventario General de Bodegas</h3>
        <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Producto</button>
      </div>
  <div class="mb-3 d-flex justify-content-start">
  <button class="btn btn-danger" @click="descargarPDF">
    <i class="bx bxs-file-pdf"></i> Generar Reporte PDF
  </button>
</div>



      <!-- Formulario -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nuevo Producto</h5>
        <div class="row g-4">
          <div class="col-md-4">
            <label class="form-label">Nombre</label>
            <input v-model="nuevoProducto.NombreProducto" type="text" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Stock Actual</label>
            <input v-model.number="nuevoProducto.StockActual" type="number" min="0" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Precio Costo (Q)</label>
            <input v-model.number="nuevoProducto.PrecioCosto" type="number" min="0" step="0.01" class="form-control" />
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarProducto">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Nombre</th>
              <th>Stock Actual</th>
              <th>Precio Costo (Q)</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="productosFiltrados.length === 0">
              <td colspan="4">No hay productos registrados.</td>
            </tr>
            <tr v-for="prod in productosFiltrados" :key="prod.IdProductoHotel">
              <td>{{ prod.NombreProducto }}</td>
              <td>{{ prod.StockActual }}</td>
              <td>Q.{{ Number(prod.PrecioCosto).toFixed(2) }}</td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(prod)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(prod)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Actualizar -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Producto</h5>
            <button type="button" class="btn-close" @click.stop="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-4">
              <div class="col-md-6">
                <label class="form-label">Nombre</label>
                <input v-model="productoEditar.NombreProducto" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Stock Actual</label>
                <input v-model.number="productoEditar.StockActual" type="number" min="0" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Precio Costo (Q)</label>
                <input v-model.number="productoEditar.PrecioCosto" type="number" min="0" step="0.01" class="form-control" />
              </div>
            </div>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarProducto">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar el producto <strong>{{ productoEliminar?.NombreProducto }}</strong>?</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "InventarioGeneralHotel",
  data() {
    return {
      productos: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      busqueda: "",
      ordenarPor: "",
      copiaLista: [],
      productoEditar: null,
      productoEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevoProducto: {
        NombreProducto: "",
        StockActual: "",
        PrecioCosto: ""
      }
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
    productosFiltrados() {
      const q = this.busqueda.trim().toLowerCase();
      let lista = q
        ? this.copiaLista.filter(p => (p.NombreProducto || '').toLowerCase().includes(q))
        : this.copiaLista.slice();
      if (this.ordenarPor) {
        const dir = this.ordenarPor.endsWith('-desc') ? -1 : 1;
        lista = lista.slice().sort((a, b) =>
          dir * (a.NombreProducto || '').localeCompare(b.NombreProducto || '')
        );
      }
      return lista;
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    limpiarFiltros() {
      this.busqueda = "";
      this.ordenarPor = "";
    },
    descargarPDF() {
      const params = {};
      if (this.busqueda.trim()) params.nombre = this.busqueda.trim();
      if (this.ordenarPor) {
        const [campo, dir] = this.ordenarPor.split('-');
        params.ordenar_por = campo;
        params.direccion = dir;
      }
    axios.get(`${API_URL}/reporte-inventarioGeneral/pdf`, {
      responseType: 'blob', params
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'reporte_inventario_general.pdf');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }).catch(error => {
      console.error('Error descargando PDF:', error);
      this.mostrarAlerta('Error al generar el reporte PDF', 'danger');
    });
  },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerProductos() {
      try {
        const { data } = await axios.get(`${API_URL}/inventario-general-hotel`);
        this.productos = data;
        this.copiaLista = data.slice();
      } catch (error) {
        console.error(error);
      }
    },
    async guardarProducto() {
      const { NombreProducto, StockActual, PrecioCosto } = this.nuevoProducto;
      if (!NombreProducto || StockActual === "" || PrecioCosto === "") {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      if (StockActual < 0) {
        this.mostrarAlerta("El stock no puede ser negativo", "danger");
        return;
      }
      try {
        await axios.post(`${API_URL}/inventario-general-hotel`, this.nuevoProducto);
        this.mostrarAlerta("Producto agregado", "success");
        this.nuevoProducto = { NombreProducto: "", StockActual: "", PrecioCosto: "" };
        this.mostrarFormulario = false;
        this.obtenerProductos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar", "danger");
      }
    },
    abrirModal(producto) {
      this.productoEditar = { ...producto };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.productoEditar = null;
      this.mostrarModal = false;
    },
    async actualizarProducto() {
      if (this.productoEditar.StockActual < 0) {
        this.mostrarAlerta("El stock no puede ser negativo", "danger");
        return;
      }
      try {
        await axios.put(`${API_URL}/inventario-general-hotel/${this.productoEditar.IdProductoHotel}`, this.productoEditar);
        this.mostrarAlerta("Producto actualizado", "success");
        this.cerrarModal();
        this.obtenerProductos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(producto) {
      this.productoEliminar = { ...producto };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mostrarModalEliminar = false;
      this.productoEliminar = null;
    },
    async confirmarEliminar() {
      if (!this.productoEliminar) return;
      try {
        await axios.delete(`${API_URL}/inventario-general-hotel/${this.productoEliminar.IdProductoHotel}`);
        this.mostrarAlerta("Producto eliminado", "success");
        this.obtenerProductos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevoProducto = { NombreProducto: "", StockActual: "", PrecioCosto: "" };
    }
  },
  mounted() {
    this.obtenerProductos();
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 550px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
